import { PageHero } from "@/components/PageHero";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { CoverageMap } from "@/components/CoverageMap";
import { Estimator } from "@/components/Estimator";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowUpRight } from "lucide-react";

export default function WhatWeDo() {
  return (
    <>
      <PageHero
        eyebrow="What We Do · 02"
        title="Four disciplines."
        italic="One practice."
        subtitle="From a first feasibility read to an adopted specific plan — and into executive management for the consortia that follow. Built on relationships with city and county departments across Southern California."
        image="https://images.unsplash.com/photo-1503708928676-1cb796a0891e"
      />

      <Services />
      <Process />
      <CoverageMap />
      <Estimator />

      <section className="bg-paper py-20 lg:py-28 border-t border-border">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
          <div>
            <span className="mono text-[10px] uppercase tracking-[0.25em] text-clay">Continue</span>
            <h3 className="font-display text-3xl lg:text-5xl text-ink mt-3 leading-tight tracking-[-0.02em]">What we have done →</h3>
          </div>
          <Button asChild className="h-12 rounded-none bg-ink text-paper hover:bg-clay mono text-[11px] uppercase tracking-[0.22em] px-6">
            <Link to="/what-we-have-done">
              Our work <ArrowUpRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </section>
    </>
  );
}
